import React from 'react';

/**
 * TextField — single-line or multi-line text input.
 * @param {string}   label       - Field label
 * @param {string}   value       - Current value
 * @param {function} onChange    - Called with new string value
 * @param {boolean}  multiline   - Use textarea instead of input
 * @param {number}   maxLength   - Max character count (shows counter)
 * @param {string}   placeholder - Placeholder text
 * @param {string}   type        - Input type (default 'text')
 * @param {boolean}  required    - Show required star
 * @param {boolean}  hasError    - Show error state
 * @param {string}   errorMsg    - Error message text
 */
function TextField({
  label,
  value,
  onChange,
  multiline,
  maxLength,
  placeholder,
  type = 'text',
  required,
  hasError,
  errorMsg,
}) {
  const handleChange = (e) => onChange(e.target.value);

  return (
    <div className="field-group">
      {label && (
        <label className="field-label">
          {label}
          {required && <span className="required-star">*</span>}
        </label>
      )}
      {multiline ? (
        <textarea
          className={`text-input${hasError ? ' has-error' : ''}`}
          value={value || ''}
          onChange={handleChange}
          placeholder={placeholder}
          maxLength={maxLength}
          aria-required={required}
          aria-invalid={hasError}
          rows={4}
        />
      ) : (
        <input
          type={type}
          className={`text-input${hasError ? ' has-error' : ''}`}
          value={value || ''}
          onChange={handleChange}
          placeholder={placeholder}
          maxLength={maxLength}
          aria-required={required}
          aria-invalid={hasError}
        />
      )}
      {maxLength && (
        <p className="char-count">
          {(value || '').length}/{maxLength}
        </p>
      )}
      {hasError && errorMsg && (
        <p className="error-message">{errorMsg}</p>
      )}
    </div>
  );
}

export default TextField;
